import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  LinearProgress,
} from '@mui/material';
import TimerIcon from '@mui/icons-material/Timer';

interface SessionExpiryModalProps {
  open: boolean;
  remainingSeconds: number;
  onExtend: () => void;
  onLogout: () => void;
  extending: boolean;
}

export function SessionExpiryModal({
  open,
  remainingSeconds,
  onExtend,
  onLogout,
  extending,
}: SessionExpiryModalProps) {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeStr = `${minutes}:${String(seconds).padStart(2, '0')}`;
  const progress = Math.min(remainingSeconds / 120, 1) * 100;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth hideBackdrop={false}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,

          fontSize: '1.1rem',
          fontWeight: 600,
          color: '#1A1A1A',
        }}
      >
        <TimerIcon sx={{ color: '#ED6C02' }} />
        Session Expiring
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontSize: '0.85rem',
            color: '#6B6560',
            mb: 2,
          }}
        >
          Your session will expire soon due to inactivity. Would you like to stay logged in?
        </Typography>
        <Box
          sx={{
            bgcolor: '#FFF8E1',
            border: '1px solid #FFE082',
            p: 2,
            mb: 2,
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontSize: '1.6rem',
              fontWeight: 700,
              color: remainingSeconds <= 30 ? '#C62828' : '#ED6C02',
            }}
          >
            {timeStr}
          </Typography>
          <Typography
            sx={{
              fontSize: '0.65rem',
              color: '#9B958F',
              mt: 0.5,
            }}
          >
            until automatic logout
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 4,
            bgcolor: '#E2DDD8',
            borderRadius: 0,
            '& .MuiLinearProgress-bar': {
              bgcolor: remainingSeconds <= 30 ? '#C62828' : '#ED6C02',
            },
          }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onLogout}
          variant="outlined"
          sx={{
            borderRadius: 0,

            fontSize: '0.75rem',
            color: '#6B6560',
            borderColor: '#D7D0C8',
            textTransform: 'none',
          }}
        >
          Logout
        </Button>
        <Button
          onClick={onExtend}
          variant="contained"
          disabled={extending}
          sx={{
            borderRadius: 0,

            fontSize: '0.75rem',
            fontWeight: 600,
            bgcolor: '#2C3E2D',
            textTransform: 'none',
            '&:hover': { bgcolor: '#1a2e1b' },
          }}
        >
          {extending ? 'Extending...' : 'Stay Logged In'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
